import {
  MONTHS,
  WEEKDAYS_SHORT,
  getMonthGrid,
  isToday,
} from '../../utils/dateUtils'

interface YearViewProps {
  year: number
  hasEventsOnDay: (d: Date) => boolean
  onSelectMonth: (d: Date) => void
}

export function YearView({ year, hasEventsOnDay, onSelectMonth }: YearViewProps) {
  return (
    <div className="year-view">
      {MONTHS.map((name, month) => {
        const grid = getMonthGrid(year, month)
        return (
          <section
            key={name}
            className="year-month"
            role="button"
            tabIndex={0}
            onClick={() => onSelectMonth(new Date(year, month, 1))}
            onKeyDown={(ev) => {
              if (ev.key === 'Enter' || ev.key === ' ') {
                ev.preventDefault()
                onSelectMonth(new Date(year, month, 1))
              }
            }}
            aria-label={`${name} ${year} — Monatsansicht öffnen`}
            title={`${name} öffnen`}
          >
            <h3 className="year-month__title">{name}</h3>
            <div className="year-month__weekdays">
              {WEEKDAYS_SHORT.map((w) => (
                <span key={w}>{w}</span>
              ))}
            </div>
            <div className="year-month__grid">
              {grid.map((d, i) => {
                const inMonth = d.getMonth() === month
                const today = isToday(d)
                const has = hasEventsOnDay(d)
                return (
                  <span
                    key={i}
                    className={[
                      'year-day',
                      !inMonth ? 'year-day--muted' : '',
                      today ? 'year-day--today' : '',
                      has ? 'year-day--events' : '',
                    ]
                      .filter(Boolean)
                      .join(' ')}
                    aria-hidden={!inMonth}
                  >
                    {inMonth ? d.getDate() : ''}
                  </span>
                )
              })}
            </div>
          </section>
        )
      })}
    </div>
  )
}
